import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTour } from '../context/TourContext';
import './TourOverlay.css';

// Simulated moderator inbox exchange shown in step 4
const INBOX_DEMO = [
  { from: 'mod',  text: 'Hi — thank you for your report near Powell St BART. Could you tell me approximately what time this happened and which direction you were heading?' },
  { from: 'user', text: 'It was around 10:15pm. I was walking south on Powell toward Market.' },
  { from: 'mod',  text: 'That\'s really helpful. Can you describe what the person was wearing? This helps us match it to any other reports in the area.' },
  { from: 'user', text: 'Dark hoodie, jeans, maybe 5\'10". He had a backpack.' },
  { from: 'mod',  text: 'Thank you. I\'ve updated the report and flagged it to SFPD\'s community liaison. Your identity remains fully anonymous throughout.' },
];

export default function TourOverlay() {
  const { currentStep, stepIndex, totalSteps, nextStep, prevStep, endTour, isTourMode } = useTour();
  const [inboxVisible, setInboxVisible] = useState(false);
  const navigate = useNavigate();

  if (!isTourMode || !currentStep) return null;

  const isFirst = stepIndex === 0;
  const isLast  = currentStep.id === 'done';
  const progress = ((stepIndex) / (totalSteps - 1)) * 100;

  const handleNext = () => {
    if (currentStep.id === 'mod_comms') setInboxVisible(true);
    if (isLast) { endTour(); navigate('/register'); return; }
    nextStep();
  };

  return (
    <>
      {/* Top demo banner */}
      <div className="tour-banner">
        Demo Mode — San Francisco Simulation
        <button className="tour-banner-skip" onClick={() => { endTour(); navigate('/'); }}>Exit tour</button>
      </div>

      {/* Step card */}
      <div className="tour-card">
        {/* Progress bar */}
        <div className="tour-progress-track">
          <div className="tour-progress-fill" style={{ width: `${progress}%` }} />
        </div>

        <div className="tour-card-body">
          <div className="tour-step-label">{currentStep.subtitle}</div>
          <h3 className="tour-card-title">{currentStep.title}</h3>
          <p className="tour-card-text">{currentStep.body}</p>

          {currentStep.hint && (
            <p className="tour-card-hint">{currentStep.hint}</p>
          )}

          {/* Inbox demo for step 4 */}
          {currentStep.id === 'mod_comms' && inboxVisible && (
            <div className="tour-inbox">
              {INBOX_DEMO.map((msg, i) => (
                <div key={i} className={`tour-msg tour-msg-${msg.from}`}>
                  <span className="tour-msg-label">{msg.from === 'mod' ? 'Moderator' : 'Reporter (anonymous)'}</span>
                  <p>{msg.text}</p>
                </div>
              ))}
            </div>
          )}

          {currentStep.id === 'mod_comms' && !inboxVisible && (
            <button className="tour-show-inbox" onClick={() => setInboxVisible(true)}>
              See example conversation
            </button>
          )}
        </div>

        <div className="tour-card-actions">
          {!isFirst && (
            <button className="tour-btn-back" onClick={prevStep}>Back</button>
          )}
          <div className="tour-dots">
            {Array.from({ length: totalSteps }).map((_, i) => (
              <span key={i} className={`tour-dot ${i === stepIndex ? 'tour-dot-active' : ''}`} />
            ))}
          </div>
          <button className="tour-btn-next" onClick={handleNext}>
            {isLast ? 'Create Account' : 'Next'}
          </button>
        </div>
      </div>
    </>
  );
}
